import { gql } from '@apollo/client';

export const BULK_UPDATE_REPORTING_REQUIREMENTS = gql`
  mutation bulkUpdateReportingRequirements($input: BulkReportingRequirementsInput!) {
    result: bulkUpdateReportingRequirements(input: $input) {
      updated
      failed {
        id
        name
        message
      }
    }
  }
`;
